<i18n src="@/i18n/components/search/filter.json"></i18n>
<template>
  <div class="filter-contact-purpose-field">
    <FilterBaseInputText
      v-model="value"
      :prefix="$t('containsPrefix')"
      :suffix="$te('containsSuffix') ? $t('containsSuffix') : ''"
    />
  </div>
</template>

<script lang="ts">
import { Component, Model, Vue } from "vue-property-decorator";
import { FilterContactPurposeCondition } from "@/models/search/filter-node-condition/FilterContactPurposeCondition";

import FilterBaseInputText from "@/components/filter/form/FilterBaseInputText.vue";

@Component({
  components: {
    FilterBaseInputText
  }
})
export default class FilterContactPurposeField extends Vue {
  @Model("input", {
    type: FilterContactPurposeCondition,
    required: true
  })
  condition!: FilterContactPurposeCondition;

  onInput(condition: FilterContactPurposeCondition) {
    this.$emit("input", condition);
  }

  get value(): string {
    return this.condition.purpose;
  }
  set value(value: string) {
    this.onInput(new FilterContactPurposeCondition(value));
  }
}
</script>
<style lang="scss" scoped>
.filter-contact-purpose-field {
  display: flex;
  align-items: center;
}

.select-box {
  margin-right: 7px;
}
</style>
